import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { GetSubscriptionSetData } from "../../../../ApiTS/ServiceDatasTS";
import { getThousandComma } from "../../../../ApiTS/ApiCommonTS";
import { TotalCount } from "../../../../pages/Users/UserInfo";
import LineBox from "../../../DefaultStyles/LineBox";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import ReportPartyListFilter from "./ReportPartyListSection/ReportPartyListFilter";
import DotStatus from "../../../DefaultStyles/DotStatus";
import { useApi } from "../../../../hooks/useApi";
import Loader from "../../../DefaultStyles/Loader";
import { useRecoilValue } from "recoil";
import { validCheckSubsIdState } from "../../../../pages/Manage/LoginCheck";
import LineBtn from "../../../Button/LineBtn";
import ReportPartyValidCheckBtn from "./ReportPartyListSection/ReportPartyValidCheckBtn";
import { toast } from "react-toastify";
import CheckBox from "../../../Button/CheckBox";
import { getSubsNameBySubsId3 } from "../../../../AdminApi/3.0_utils";

interface IListErrParty {
  id: number;
  idtype: string;
  pid: number;
  state: number;
  subsid: number;
  uid: number;
  updatedate: number;
  wrong: number;
}

export default function ReportPartyListSection() {
  const navigate = useNavigate();

  const validCheckSubsId = useRecoilValue(validCheckSubsIdState);
  const [prevResult, setPrevResult] = useState({
    login: false,
    membership: false,
    secondaryAuth: false,
  });
  const [loginInfo, setLoginInfo] = useState({
    shareid: "",
    password: "",
  });
  const [partyInfo, setPartyInfo] = useState({
    id: 0,
    ownerId: 0,
    subsId: 0,
    partyId: 0,
  });
  const [fetchList, setFetchList] = useState(false);
  const [page, setPage] = useState(0);
  const [resetSearchValue, setResetSearchValue] = useState(false);
  const [filter, setFilter] = useState({
    type: "",
    value: "",
  });
  const [search, setSearch] = useState<{
    type: string;
    value: string | undefined;
  }>({
    type: "",
    value: "",
  });
  const [renderBtn, setRenderBtn] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const [selected, setSelected] = useState<{ [key: number]: any }>({});

  console.log(selected);
  console.log(Object.values(selected));

  console.log("renderBtn", renderBtn);

  // subsId 별 신고 파티 리스트
  const { response, loading } = useApi({
    method: "get",
    url: fetchList
      ? `temp-account/listErrParty?page=${page}&size=10` +
        (filter?.type === "subscription" ? `&subsid=${+filter.value}` : ``) +
        (filter?.type === "check"
          ? `&subsid=0&wrong=${filter.value === "login" ? 1 : 2}`
          : ``) +
        (search?.value !== "" ? `&${search?.type}=${search.value}` : ``)
      : undefined,
  });

  // 유효성 체크할 파티의 로그인 정보
  const {
    response: loginResponse,
    loading: loginLoading,
    error: loginError,
  } = useApi({
    method: "post",
    url:
      partyInfo?.partyId > 0 ? `party/${partyInfo?.partyId}/login` : undefined,
  });

  const disabledMembershipCheck = false;

  const reportedPartyListHeader = [
    <CheckBox
      checked={allSelected}
      onChange={() => {
        setAllSelected((prev) => !prev);
      }}
    />,
    "Subscription",
    "PID",
    "파티장 UID",
    "로그인 타입",
    "로그인 체크",
    "이용권 체크",
    "신고 위치",
    "신고 일시",
    "유효성 체크",
  ];

  const btnRefreshEvent = () => {
    setRenderBtn(false);
    setPrevResult({
      login: false,
      membership: false,
      secondaryAuth: false,
    });
    setPartyInfo({
      id: 0,
      ownerId: 0,
      partyId: 0,
      subsId: 0,
    });
    setFetchList(true);
    setSelected({});
  };

  useEffect(() => {
    if (response?.status === 200) {
      setFetchList(false);
      setLoginInfo({
        shareid: "",
        password: "",
      });
    }
  }, [response]);

  // 로그인 정보 패킷 성공시
  useEffect(() => {
    if (loginResponse?.status === 201) {
      setLoginInfo({
        shareid: loginResponse?.data?.shareid ?? "",
        password: loginResponse?.data?.password ?? "",
      });
      setRenderBtn(true);
    }
  }, [loginResponse]);

  useEffect(() => {
    if (loginError) {
      btnRefreshEvent();
      toast.error(
        loginError?.data ?? "파티 로그인 정보를 가져오는 데에 실패하였습니다."
      );
    }
  }, [loginError]);

  useEffect(() => {
    console.log("renderBtn", renderBtn);

    setResetSearchValue(true);
    setFilter({
      type: "subscription",
      value: `${validCheckSubsId > 0 ? validCheckSubsId : 0}`,
    });
  }, []);

  useEffect(() => {
    setFetchList(true);
    setRenderBtn(false);
  }, [filter, search, page]);

  useEffect(() => {
    let obj: { [key: number]: any } = {};

    if (allSelected) {
      let obj: { [key: number]: any } = {};

      response?.data?.items?.forEach((d: any, i: number) => {
        obj[i] = d?.id;
      });

      setSelected(obj);
    } else {
      obj = {};
      setSelected(obj);
    }
  }, [allSelected]);

  return (
    <Section>
      <ReportPartyListFilter
        resetPage={() => setPage(0)}
        resetSearchValue={resetSearchValue}
        setFilter={setFilter}
        setSearch={setSearch}
        selectedReportId={Object.values(selected)}
        refreshEvent={() => {
          btnRefreshEvent();
        }}
      />

      <LineBox>
        <Table tableHeadData={reportedPartyListHeader}>
          <>
            {response?.data?.items?.map((d: IListErrParty, i: number) => {
              return (
                <TableBody key={d?.updatedate}>
                  <TableBodyItem>
                    <CheckBox
                      checked={selected?.[i]}
                      onChange={() => {
                        if (selected?.[i]) {
                          setSelected({
                            ...selected,
                            [i]: null,
                          });
                        } else {
                          setSelected({
                            ...selected,
                            [i]: d?.id,
                          });
                        }
                      }}
                    />
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.subsid}_{getSubsNameBySubsId3(d?.subsid)}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable={true}
                    onClick={() => navigate(`/party/info/${d?.pid}`)}
                  >
                    {d?.pid}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable={true}
                    onClick={() => navigate(`/users/info/${d?.uid}`)}
                  >
                    {d?.uid}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.idtype === "" ? "-" : d?.idtype}
                  </TableBodyItem>
                  <TableBodyItem>
                    <DotStatus
                      text={
                        d?.wrong === 1 || d?.wrong === undefined
                          ? "실패"
                          : d?.wrong === 4
                          ? "2차 인증 필요"
                          : "성공"
                      }
                      color={
                        d?.wrong === 1 ||
                        d?.wrong === undefined ||
                        d?.wrong === 4
                          ? "#f42d16"
                          : "#00c7c7"
                      }
                      size="sm"
                    />
                  </TableBodyItem>
                  {!disabledMembershipCheck && (
                    <TableBodyItem>
                      <DotStatus
                        text={
                          d?.wrong === 2
                            ? "실패"
                            : d?.wrong === undefined ||
                              d?.wrong === 1 ||
                              d?.wrong === 4
                            ? "알 수 없음"
                            : "성공"
                        }
                        color={
                          d?.wrong === 2
                            ? "#f42d16"
                            : d?.wrong === undefined ||
                              d?.wrong === 1 ||
                              d?.wrong === 4
                            ? "#ffb100"
                            : "#00c7c7"
                        }
                        size="sm"
                      />
                    </TableBodyItem>
                  )}
                  <TableBodyItem>
                    {d?.state === 1
                      ? "파티 만들기"
                      : d?.state === 2
                      ? "공유 정보 수정"
                      : d?.state === 3
                      ? "임시 계정 발급"
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem>
                    {dayjs(d?.updatedate)?.format("YYYY-MM-DD HH:mm")}
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="체크"
                      btnClickEvent={() => {
                        setPrevResult({
                          login: d?.wrong === 1 ? true : false,
                          membership: d?.wrong === 2 ? true : false,
                          secondaryAuth: d?.wrong === 4 ? true : false,
                        });
                        setPartyInfo({
                          id: d?.id,
                          ownerId: d?.uid,
                          partyId: d?.pid,
                          subsId: d?.subsid,
                        });
                      }}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {(loading || loginLoading) && <Loader />}

      {renderBtn && (
        <ReportPartyValidCheckBtn
          loginInfo={loginInfo}
          partyInfo={partyInfo}
          prevResult={prevResult}
          refreshEvent={() => {
            btnRefreshEvent();
          }}
        />
      )}
    </Section>
  );
}

const Section = styled.section`
  margin-top: 40px;
`;
